import React from "react";
import MobileWorkExperienceEntry from "./contentCards/mobileExperienceEntry";
import { workExperiences } from "../../data";

const MobileExperiences = () => {
  return (
    <div className="text-white">
      <div
        style={{
          fontSize: "3em",
          fontWeight: "300",
          lineHeight: "1.25",
        }}
        className="py-2"
      >
        Work Experience
      </div>
      {workExperiences.map((exp) => (
        <MobileWorkExperienceEntry key={exp.id} experience={exp} />
      ))}
    </div>
  );
};

export default MobileExperiences;
